document.addEventListener("DOMContentLoaded", () => {
  const discountInterval = setInterval(function () {
    if(document.querySelector(".docapp-coupon-input--input")){
    if (
      document.querySelector(".docapp-cart-discount .money") &&
      !document
        .querySelector(".ed-product .label--highlight")
        .classList.contains("label--with-discount")
    ) {
      document.querySelector("#special-section").style.display = "none";
      let discountAmount = document.querySelector(
        ".docapp-cart-discount .money"
      ).textContent;
      let discountCode = document
        .querySelector(".docapp-coupon-input--bean-container--bean-remove")
        .getAttribute("data-code");

      document.querySelector(
        ".discount-bar .discount-bar--code"
      ).textContent = discountCode;
      document.querySelector(
        ".discount-box .mini-cart__discount-badge-discount-bar"
      ).textContent = discountCode;
      document.querySelector(
        ".discount-bar .discount-bar--price"
      ).textContent = "-" + discountAmount;

      let originalValueElement = document.querySelector(
        ".ed-product .ed-save-amount"
      );
      let originalValue = originalValueElement.textContent;

      originalValue = parseFloat(
        originalValue.replace("€", "").replace(",", ".")
      );

      let updatedValue =
        originalValue +
        Math.abs(parseFloat(discountAmount.replace("€", "").replace(",", ".")));

      updatedValue = "€" + updatedValue.toFixed(2).replace(".", ",");

      originalValueElement.textContent = updatedValue;

      document
        .querySelector(".ed-product .label--highlight")
        .classList.add("label--with-discount");
      let largePrice = document
        .querySelector(".ed-product .price.price--highlight.price--large")
        .getAttribute("data-ed-price");
      let newLargePrice = largePrice / 100;
      newLargePrice =
        newLargePrice -
        Math.abs(parseFloat(discountAmount.replace("€", "").replace(",", ".")));
      newLargePrice = "€" + newLargePrice.toFixed(2);
      newLargePrice = newLargePrice.replace(".", ",");

      // document.querySelector(
      //   ".ed-product .price.price--highlight.price--large"
      // ).textContent = newLargePrice;

      document.querySelector(".discount-bar").style.display = "flex";
      document.querySelector(".discount-box").style.display = "flex";
      document.querySelector("#regular-discount-bar").style.display = "block";
    }

    if (
      !document.querySelector(".docapp-cart-discount .money") &&
      document
        .querySelector(".ed-product .label--highlight")
        .classList.contains("label--with-discount")
    ) {
      document.querySelector("#regular-discount-bar").style.display = "none";
      document.querySelector(".discount-box").style.display = "none";
      let largePrice = document
        .querySelector(".ed-product .price.price--highlight.price--large")
        .getAttribute("data-ed-price");
      largePrice = largePrice / 100;
      largePrice = "€" + largePrice;
      largePrice = largePrice.replace(".", ",");
      // document.querySelector(
      //   ".ed-product .price.price--highlight.price--large"
      // ).textContent = largePrice;

      let saveAmount = document
        .querySelector(".ed-product .label--highlight.label--with-discount")
        .getAttribute("data-original");
      saveAmount = saveAmount / 100;
      saveAmount = "€" + saveAmount;
      saveAmount = saveAmount.replace(".", ",");
      document.querySelector(
        ".ed-product .label--highlight.label--with-discount .ed-save-amount"
      ).textContent = saveAmount;

      document
        .querySelector(".ed-product .label--highlight")
        .classList.remove("label--with-discount");
    }


  }
    
  }, 1000);
});


document.body.addEventListener('docapp-discount-applied', (e) => {
  setTimeout(function(){
  // fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
  // const cartContent = await response2.json();
  // document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
  //   bubbles: true,
  //   detail: {
  //     cart: cartContent,
  //     openMiniCart: window.themeVariables.settings.cartType === "drawer" && $("body").find(".drawer") === null
  //   }
  // }));
  // });
    
  },1600)
});

// Function to fetch the HTML of the mini-cart and update the current page
function updateMiniCart() {
    // Fetch the HTML content from the server (assuming '/cart' returns the mini-cart)
    fetch('/')
        .then(response => response.text())
        .then(html => {
            // Create a temporary DOM element to parse the fetched HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Extract the mini-cart content from the fetched HTML
            const fetchedMiniCart = tempDiv.querySelector('#mini-cart');
console.log('updateMiniCart',fetchedMiniCart);
            // Update the current mini-cart on the page with the fetched content
            const currentMiniCart = document.getElementById('mini-cart');
            if (currentMiniCart && fetchedMiniCart) {
                currentMiniCart.innerHTML = fetchedMiniCart.innerHTML;
            }
        })
        .catch(error => console.error('Error fetching the mini-cart:', error));
}



